(() => {
  const selector = '.jdgm-revs-tab__header .jdgm-revs-tab__url[href]';

  function removeMissingPageLink(root) {
    const links = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) links.push(root);
    for (const link of links) {
      const url = new URL(link.getAttribute('href'), location.href);
      if (url.origin === location.origin && url.pathname.replace(/\/$/, '') === '/pages/reviews') {
        link.removeAttribute('href');
      }
    }
  }

  function observePanel(panel) {
    removeMissingPageLink(panel);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') removeMissingPageLink(record.target);
        for (const node of record.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) removeMissingPageLink(node);
        }
      }
    }).observe(panel, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
  }

  const panel = document.querySelector('.jdgm-revs-tab');
  if (panel) {
    observePanel(panel);
  } else {
    const observer = new MutationObserver(() => {
      const injectedPanel = document.querySelector('.jdgm-revs-tab');
      if (injectedPanel) {
        observer.disconnect();
        observePanel(injectedPanel);
      }
    });
    observer.observe(document.body, {childList: true, subtree: true});
  }
})();
